<app-site-widget
	[title]="title"
	[elementId]="elementId"
	[widgetClass]="widgetClass"
	[data]="data"
	[siteWidgetOptions]="siteWidgetOptions"
	[config]="config"
	[tableColumns]="tableColumns"
	[siteId]="siteId"
	[customerId]="customerId"
	[customerName]="customerName"
	[siteName]="siteName"
></app-site-widget>